export const getApiRoot = () => {
    if (typeof window !== "undefined") {
        return `${window.location.protocol}//${window.location.hostname}:${window.location.port}/api`;
    } else {
        return process.env.GATSBY_API_ROOT ?? "";
    }
};
